import script from "./BarChartComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./BarChartComponent.vue?vue&type=script&setup=true&lang=js"

import "./BarChartComponent.vue?vue&type=style&index=0&id=3089359c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3089359c"]])

export default __exports__